import { useEffect } from "react";
import "@/App.css";
import { ReactLenis, useLenis } from "lenis/react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Navbar } from "@/components/portfolio/Navbar";
import Home from "@/pages/Home";
import InstructionalDesignPage from "@/pages/InstructionalDesignPage";
import PhotographyPage from "@/pages/PhotographyPage";
import WebGraphicPage from "@/pages/WebGraphicPage";
import InteriorPage from "@/pages/InteriorPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  const lenis = useLenis();
  useEffect(() => {
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, lenis]);
  return null;
}

function LenisBridge() {
  const lenis = useLenis();
  useEffect(() => {
    if (!lenis) return;
    window.__lenis = lenis;
    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const href = a.getAttribute("href");
      if (href && href.length > 1) {
        e.preventDefault();
        const target = document.querySelector(href);
        if (!target) return;
        const go = () => lenis.scrollTo(target, { offset: -80, duration: 0.9 });
        go();
        let tries = 0;
        const iv = setInterval(() => {
          tries += 1;
          const top = target.getBoundingClientRect().top;
          if (Math.abs(top - 80) > 6 && tries < 10) go();
          else clearInterval(iv);
        }, 220);
      }
    };
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, [lenis]);
  return null;
}

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <BrowserRouter>
        <LenisBridge />
        <ScrollToTop />
        <div className="App grain relative bg-paper text-ink font-grotesk">
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/instructional-design" element={<InstructionalDesignPage />} />
              <Route path="/photography-videography" element={<PhotographyPage />} />
              <Route path="/web-graphic-design" element={<WebGraphicPage />} />
              <Route path="/interior-design" element={<InteriorPage />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
        </div>
      </BrowserRouter>
    </ReactLenis>
  );
}

export default App;
